import { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import { assetPrefix } from 'config/env_config'
import { useServiceScheduleContext, actionTypes } from '../../../context/serviceScheduleContext'
import { usePetAndServicesContext } from '../../../context/petAndServicesContext'
import { SCHEDULING_STEPS } from '../../../utils/schedulingConstants'

const useFormStepCommon = ({ context }) => {
  const { state, steps, dispatch, functions } = useServiceScheduleContext()
  const {
    activeStep,
    scheduleBody
  } = state

  const {
    handleUnselectPet,
    handleUnselectPurchasedPackage
  } = functions

  const { functions: petFunctions } = usePetAndServicesContext()
  const { retrievePetsData } = petFunctions

  const router = useRouter()

  const [numberOfSteps, setNumberOfsteps] = useState(0)

  const currentStep = steps.find((step) => step.step === activeStep)
  const nextDisabled = currentStep?.disabledRule || context.isLoading
  const nextHidden = currentStep?.nextHiddenRule

  const backButtonProps = {
    className: 'backButton',
    textDecoration: 'underline',
    label: 'Voltar'
  }

  const nextButtonProps = {
    className: 'nextButton',
    disabled: nextDisabled,
    icon: `${assetPrefix}/static/icons/${nextDisabled ? 'arrow-right-disabled' : 'arrow-right'}.svg`,
    label: 'Avançar'
  }

  useEffect(() => {
    setNumberOfsteps(steps?.length)
  }, [steps])

  useEffect(() => {
    const footerElement = document.getElementById('footer')
    if (footerElement && activeStep === SCHEDULING_STEPS.PET_AND_SERVICE && !nextDisabled) {
      footerElement.style.marginBottom = '90px'
    } else if (footerElement) {
      footerElement.style.marginBottom = '88px'
    }

    setNumberOfsteps(steps?.length)

    return () => {
      if (footerElement) {
        footerElement.style.marginBottom = ''
      }
    }
  }, [steps, nextHidden, activeStep, nextDisabled])

  const onUpdateScheduling = (value) => {
    dispatch({ type: actionTypes.UPDATE_STATE, payload: value })
  }

  const onGoTo = (path) => {
    const stepToSet = steps.find(item => item.path === path)

    dispatch({ type: actionTypes.UPDATE_STATE, payload: { activeStep: stepToSet?.step } })

    const query = { ...router.query, showDiary: false }

    router.push({
      pathname: `/agendamentos${path}`,
      query: query
    })
  }

  const redirectToServices = async (additionalLogic) => {
    if (additionalLogic) {
      return additionalLogic()
    }

    if (scheduleBody.pet_id) {
      await retrievePetsData({ context })
      handleUnselectPet()
      return handleUnselectPurchasedPackage()
    }
    window.localStorage.removeItem('category')
    window.localStorage.removeItem('schedulingState')
    window.localStorage.removeItem('paymentState')

    await router.push('/')
  }

  return {
    activeStep,
    numberOfSteps,
    currentStep,
    nextDisabled,
    nextHidden,
    steps,
    backButtonProps,
    nextButtonProps,
    onUpdateScheduling,
    onGoTo,
    redirectToServices
  }
}

export default useFormStepCommon
